import React from "react"
import { Modal } from "react-bootstrap"
import "../css/InstallPlasticise.css"

const browserContent = {
  safari: {
    title: "Install Plasticise in Safari",
    steps: [
      "Tap Share in Safari. If you see the Page Menu button first, tap it and then Share.",
      "Scroll down and tap Add to Home Screen.",
      "Turn on Open as Web App.",
      "Tap Add.",
    ],
    help:
      "If Add to Home Screen is missing, scroll to the bottom of the Share menu, tap Edit Actions, and add it.",
  },
  chrome: {
    title: "Install Plasticise in Chrome",
    steps: [
      "Tap Share to the right of the address bar.",
      "Tap Add to Home Screen.",
      "Confirm the Plasticise details, then tap Add.",
    ],
  },
  firefox: {
    title: "Install Plasticise in Firefox",
    steps: [
      "Tap the Share icon in Firefox.",
      "Tap Add to Home Screen.",
      "Confirm the name, then tap Add.",
    ],
  },
  other: {
    title: "Install Plasticise on your iPhone",
    steps: [
      "Open your browser's Share menu.",
      "Look for Add to Home Screen and follow the prompts.",
      "If that option is not available, open Plasticise in Safari and use Safari's Add to Home Screen option.",
    ],
  },
}

const IOSInstallInstructions = ({ show, onHide, browser = "other" }) => {
  const content = browserContent[browser] || browserContent.other

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="ios-install-modal"
      dialogClassName="ios-install-dialog"
      aria-labelledby="ios-install-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="ios-install-title" className="h5 mb-0">
          {content.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted">
          Add Plasticise to your Home Screen so it opens like an app.
        </p>
        <ol className="ios-install-steps">
          {content.steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
        {content.help && (
          <p className="ios-install-help mb-3">
            <strong>Can't see Add to Home Screen?</strong> {content.help}
          </p>
        )}
        <p className="fw-semibold mb-0">
          Once installed, open Plasticise from the web app on your phone’s Home Screen.
        </p>
      </Modal.Body>
    </Modal>
  )
}

export default IOSInstallInstructions
